import React from "react";
import { Link } from "react-router-dom";
import portrait from "../../Assets/home_main.jpg";
import aboutPhoto from "../../Assets/about.png";
import ScrollReveal from "../ScrollReveal";
import HeroCTA from "./HeroCTA";
import { nowItems } from "../../data/experiences";
import { projects } from "../../data/projects";

function Home() {
  return (
    <main className="page">
      <section className="hero">
        <div className="hero-copy">
          <p className="eyebrow">New York &amp; Maryland</p>
          <h1 className="display-name">Nicole Luo</h1>
          <p className="lede">
            I write software for systems that have to work, and more importantly for the people who have to live with them.
          </p>
          <p className="prose">
            I'm a Computer Science major in Cornell’s Duffield College of Engineering, and I'm minoring in Linguistics. Lately I have been
            thinking about language as an interface, and about making complicated things feel
            a little more considered.
          </p>
          <HeroCTA />
        </div>
        <figure className="hero-portrait" data-flourish>
          <img src={portrait} alt="Nicole with a giat" />
          <figcaption>An idyllic goat farm in Ithaca, NY.</figcaption>
        </figure>
      </section>

      <ScrollReveal>
        <section className="now-section" id="now">
          <p className="section-kicker">Currently</p>
          <ul className="now-list">
            {nowItems.map((item) => (
              <li key={item.company}>
                <span className="now-place">{item.company}</span>
                <span className="now-note">
                  <span className="now-role">{item.role}</span>
                  {item.note}
                </span>
              </li>
            ))}
          </ul>
        </section>
      </ScrollReveal>

      <ScrollReveal>
        <section className="selected-section" id="work">
          <div className="section-head">
            <p className="section-kicker">Selected work</p>
            <h2 className="section-title">A few things I have made</h2>
          </div>
          <ol className="work-index">
            {projects.map((project, index) => (
              <li key={project.id}>
                <Link to="/project" className="work-index-row">
                  <span className="work-index-num">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="work-index-body">
                    <span className="work-index-title">{project.title}</span>
                    <span className="work-index-line">{project.headline}</span>
                  </span>
                  <span className="work-index-meta">{project.context}</span>
                </Link>
              </li>
            ))}
          </ol>
          <p className="section-more">
            <Link to="/project">All of the work</Link>
            <span aria-hidden="true"> · </span>
            <Link to="/experiences">Where I have been</Link>
          </p>
        </section>
      </ScrollReveal>

      <ScrollReveal>
        <section className="letter-section" id="about">
          <div className="letter-copy">
            <p className="section-kicker">A little more...</p>
            <h2 className="section-title">About Me</h2>
            <div className="prose">
              <p>
                I am a software engineer with a passion for building products that are both functional and user-friendly. To build with empathy and intention is my ultimate goal.
              </p>
              <p>
                In my free time, I love to do Sudokus, discover new restaurants and films to indulge in, and spend quality time with my friends and family.
              </p>
            </div>
          </div>
          <figure className="letter-photo" data-flourish>
            <img src={aboutPhoto} alt="Nicole Luo beside a waterfall in the woods" />
            <figcaption>A gorge, offering a waterfall.</figcaption>
          </figure>
        </section>
      </ScrollReveal>
    </main>
  );
}

export default Home;
